import React from 'react';
import {connect} from 'react-redux';
import style  from './style.css'
import { CirclePicker, ChromePicker } from 'react-color';

import Arrow from '/app/src/component/Arrow';
import {SVGButton, Flex} from '/app/src/component'
import TextInput from '/app/src/component/Forms/TextInput';
import SelectInput from '/app/src/component/Forms/SelectInput';
import {H3} from '/app/src/component/Html';

import CustomizationModel from '/app/src/model/Customization/model';
import CustomizationSelector from '/app/src/model/Customization/selector';
import * as CompanySelectors from '/app/src/model/Company/selector';

class CustomizationMainPanel extends React.Component {
    constructor(props){
        super(props)

        this.state = {
            'chromePicker': false,
            'color': this.props.customization.color,
            'displayName': this.props.displayName,
            'language': this.props.customization.language,
            'timezone': this.props.customization.timezone,
            'timezones': this.props.customization.timezones,
            'timezoneValue': String(0),
            'changed': false
        }

        this._colorPickerChange = this._colorPickerChange.bind(this)
        this._displayNameChange = this._displayNameChange.bind(this)
        this._saveButtonHandler = this._saveButtonHandler.bind(this)
        this._onColorPickerClick = this._onColorPickerClick.bind(this);
        this._getTimeZoneFromMap = this._getTimeZoneFromMap.bind(this);

        this.onChangeLanguage = this.onChangeLanguage.bind(this);
        this.onChangeTime = this.onChangeTime.bind(this);
        this.colorPickerRef = React.createRef()
        this.handleClick = this.handleClick.bind(this)
    }

    handleClick(e){
        if(!this.colorPickerRef || !this.colorPickerRef.current) return;
        if(this.colorPickerRef.current.contains(e.target)){
            return;
        }
        this.setState({chromePicker: false})
    }
    componentDidMount(){
        this._getTimeZoneFromMap();
        document.addEventListener('mousedown', this.handleClick, false)
    }

    componentWillUnmount(){
        document.removeEventListener('mousedown', this.handleClick, false)

    }

   componentDidUpdate(prevProps, prevState){
        if(prevProps.timezones !== this.props.timezones){
            this._getTimeZoneFromMap();
            this.setState({
                timezones: this.props.timezones,
                color: this.props.color,
                displayName: this.props.displayName,
                timezone: this.props.timezone,
                language: this.props.language,
                changed: false,
            });
        }

        if(prevState.timezone !== this.state.timezone){
            this._getTimeZoneFromMap();
        }
   }
    _saveButtonHandler(event){
        const color = this.state.color;
        const displayName = this.state.displayName;
        const language = this.state.language;
        const timezone = this.state.timezones[this.state.timezoneValue];
        this.props.dispatch(CustomizationModel.update(color, displayName, language, timezone))
        setTimeout(() => {
            this.setState({changed: false})
        }, 500);
    }
    _renderPreview(){
        let customStyle =  {
            backgroundColor: this.state.color
        }
        let title = 'Välkommen till';
        let faqText = 'Sök bland vanliga frågor';
        let buttonText = 'Börja chatta';

        if(this.state.language === 'en'){
            title = 'Welcome to';
            faqText = 'Frequently Asked Questions';
            buttonText = 'Start chatting'
        }

        if(this.state.language === 'no'){
            title = 'Velkommen til';
            faqText = 'Vanlige spørsmål og svar';
            buttonText = 'Start Chat'
        }
        return (
            <Flex className={style.PreviewContainer} column hAlignContent='center' vAlignContent='center' grow width='90%'>
                <Flex className={style.Preview} column>
                    <Flex style={customStyle} className={style.PreviewHeader} column>
                        <Flex className={style.WelcomeTo} hAlignContent='center'> {title} </Flex>
                        <Flex className={style.Title} hAlignContent='center'> {this.state.displayName} </Flex>
                        <Flex hAlignContent='center' grow>
                        <Flex className={style.AutoMessage}>Här visas ert automeddelande. Använd menyn till höger för att lägga till och skräddarsy era egna meddelanden</Flex>
                        </Flex>
                        <Flex className={style.FAQWrapper} hAlignContent='center' >
                            <Flex className={style.FAQ} hAlignContent='center' vAlignContent='center'>
                                <Flex> FAQ | </Flex>
                                <Flex> {faqText} </Flex>
                            </Flex>

                        </Flex>
                    </Flex>

                    <Flex className={style.PreviewBody} column hAlignContent='center' vAlignContent='center' grow>
                        <Flex style={customStyle} className={style.ChatButton} hAlignContent='center' vAlignContent='center'> {buttonText} </Flex>
                        <Flex className={style.Powered} vAlignContent='bottom'> Powered by Jibber </Flex>
                    </Flex>
                </Flex>

                <Flex className={style.AutoMessageWrapper}  width='100%' hAlignContent='right'>
                </Flex>

                <Flex className={style.BubbleButtonWrapper}  width='100%' hAlignContent='right'>
                    <img alt='bubbleButton' className={style.BubbleButton} style={customStyle} src='/images/ClientChatOpen.png'/>
                </Flex>

            </Flex>
        )

    }

    _displayNameChange(event){
        this.setState({displayName: event.target.value, changed: true})
    }

    onChangeLanguage(event){
        this.setState({language: event.target.value, changed: true});
    }

    onChangeTime(event){
        this.setState({timezoneValue: event.target.value, changed: true});
    }

    _colorPickerChange(color){
        this.setState({color: color.hex, changed: true})
    }

    _onColorPickerClick(){
        this.setState({chromePicker: !this.state.chromePicker});
    }

    _getTimeZoneFromMap(){

        let timezoneValue = 0;
        if(this.state.timezones){
            this.state.timezones.map((timezone, index) => {
                if(this.state.timezone === timezone){
                    timezoneValue = index;
                    this.setState({
                        timezoneValue: index.toString(),
                    })
                }
                return false;
            })
        }
        return timezoneValue.toString();
    }

    _renderCustomization(){
        let hexColorBorder = 'solid 1px #707070';
        if(this.state.chromePicker){
            hexColorBorder = 'solid 2px #4ec1e0';
        }
        return (
            <Flex className={style.CustomizeContainer} column width='70%' hAlignContent='center' wrap>

                <Flex className={style.CustomName} column width='100%'>
                    <H3 marginBottom='5px'>Visningsnamn/Företagsnamn</H3>
                    <TextInput maxLength='20' placeholder='Företagsnamn/Titel' label='Visningsnamn' autoComplete='organization' name='companyName' value={this.state.displayName} onChange={this._displayNameChange}/>
                </Flex>
                <Flex hAlignContent='left' width='100%' className={style.Label}>
                    Färg
                </Flex>
                <Flex className={style.CustomColor} hAlignContent='center' column width='100%'>

                    <Flex className={style.CirclePicker} hAlignContent='center' vAlignContent='center'>
                        {
                        this.state.chromePicker ?
                            <ChromePicker disableAlpha color={this.state.color} onChange={this._colorPickerChange}/>
                        :
                        <CirclePicker
                            colors={['#4dc5e2', '#2dcc70', ' #f64b7f',
                                            ' #f1c50d', ' #e77e22', '#ef4129',
                                            '#9a59b5', '#34495e', ' #000000']}
                            circleSize={40}
                            circleSpacing={20}
                            onChangeComplete={this._colorPickerChange}
                        />

                        }

                    </Flex>
                    <Flex mb='4px'> Välj egen</Flex>
                    <Flex className={style.ColorPickerButton} style={{border: hexColorBorder}} onClick={this._onColorPickerClick}>


                        <Flex className={style.Color} style={{backgroundColor: this.state.color}}>
                        </Flex>
                        <Flex className={style.Hex} hAlignContent='center' vAlignContent='center' grow>
                            {this.state.color}
                            <Flex basis='30%' hAlignContent='center'>
                            <Arrow onClick={this._onColorPickerClick} direction='down' small/>
                            </Flex>

                        </Flex>
                    </Flex>
                    <Flex className={style.Reminder}> Tänk på att ljusa färgval kan påverka läsbarheten.</Flex>
                </Flex>
                <Flex className={style.CustomLanguage} column width='100%'>
                    <H3 marginBottom='5px'>Visningsspråk</H3>
                    <SelectInput values={{se: 'Svenska', en: 'Engelska', no: 'Norska'}} select={this.props.language} onChange={this.onChangeLanguage}/>
                </Flex>
                <Flex className={style.CustomTimeZone} column width='100%'>
                    <H3 marginBottom='5px'>Tidszon</H3>
                    <SelectInput values={this.state.timezones} select={this.state.timezoneValue} onChange={this.onChangeTime}/>
                </Flex>
        </Flex>
        )

    }

    render() {
        if(!this.props.customization.timezones){
            return 'loading...'
        }
        return(
            <Flex w='100%' h='100%' column hAlignContent='center' position='relative'>
                <Flex w='100%' vAlignContent='center' hAlignContent='right' padding='30px' column>
                    <SVGButton
                        border text='Spara' src='/images/Save.svg' onClick={this._saveButtonHandler}
                        color='black' hover='blue' disabled={!this.state.changed}
                    />
                    <Flex h='10px' fontSize='12px' fontWeight='400' color='darkgrey' mt='2px'>
                        {this.state.changed && '*Ändringar är inte sparade'}
                    </Flex>
                </Flex>
                <Flex h='100%' w='100%' center overflowY='auto' wrap>
                    <Flex mt='20px' column basis='400px' center grow={0} shrink={0}>
                        {this._renderPreview()}
                    </Flex>
                    <Flex marginTop='20px' basis='400px' center grow={0} shrink={0} marginBottom='100px'>
                        {this._renderCustomization()}
                    </Flex>
                </Flex>
            </Flex>
        )
    }
}

function mapStateToProps(state, props){
    const customization = CustomizationSelector.getFrom(state);
    const companyInfo = CompanySelectors.getCompanyInfo(state);
    const companyName = companyInfo.get('name');
    let displayName = customization.get('company_display_name')
    const language = customization.get('default_language')

    if(!displayName) displayName = companyName;
    return {
        customization: customization.toJS(),
        displayName: displayName,
        language: language
    }

}
export default connect(mapStateToProps)(CustomizationMainPanel);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/Customization/index.js